import MuiOutlinedInput, { OutlinedInputProps as MuiOutlinedInputProps } from '@mui/material/OutlinedInput';
import { forwardRef } from 'react';

export type IOutlinedInputProps = Omit<MuiOutlinedInputProps, 'name' | 'ref'> & {
    name: string;
};

export const OutlinedInput = forwardRef<HTMLDivElement, IOutlinedInputProps>(function OutlinedInputInner(
    { name, ...rest },
    ref
) {
    return <MuiOutlinedInput ref={ref} {...rest} name={name} />;
});
